/**
 * Section 4 of Antonin's catalog, the encounter middle (the visit note), behind the `encounterLatest` switch
 * (`?x=encounter-latest`). It only sets or removes `data-enc-latest="on"` on the root element. Every rule of
 * `src/styles/showcase-encounter-latest.css` is scoped to that attribute, so with the switch off nothing changes.
 */
export function applyEncounterLatestLook(on: boolean, root: HTMLElement = document.documentElement): void {
  if (on) root.dataset.encLatest = 'on';
  else delete root.dataset.encLatest;
}
